import React from "react";
import { NavLink as RouterNavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  Container,
  Navbar,
  Nav,
  NavItem,
  NavLink,
  NavbarBrand,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

import { useAuth0 } from "@auth0/auth0-react";
import logolt from "../assets/logo.svg";
import { useTranslation } from "react-i18next";
import contactUsSvg from "../assets/Contact_Us_Icon_navbar.svg";
import ContactIcon from "./ContactIcon";

const NavBar = () => {
  const { t } = useTranslation();
  const { user, logout } = useAuth0();

  const contactUsSvgPath = contactUsSvg;

  const logoutWithRedirect = () =>
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      }
    });

  return (
    <div className="nav-container">
      <Navbar color="dark" dark expand="xs" container={false}>
        <Container className="navbar-flex-root">
          <NavbarBrand
            tag={RouterNavLink}
            to="/"
            className="nav-brand-inline"
            aria-label="Home"
          >
            <img alt="logo" src={logolt} className="nav-brand-img" />
          </NavbarBrand>

          <div className="nav-controls-row">
            <Nav className="mr-auto nav-left-group" navbar>
              <NavItem>
                <NavLink
                  tag={RouterNavLink}
                  to="/"
                  exact
                  activeClassName="router-link-exact-active"
                >
                  {t("Navigation-Live")}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  tag={RouterNavLink}
                  to="/geek_corner"
                  exact
                  activeClassName="router-link-exact-active"
                >
                  {t("Navigation-Geek Corner")}
                </NavLink>
              </NavItem>
            </Nav>
            <Nav className="ml-auto nav-right-group d-flex align-items-center" navbar>
              <NavItem className="d-flex align-items-center mx-2 contact-item">
                <ContactIcon src={contactUsSvgPath} />
              </NavItem>
              <UncontrolledDropdown nav container="body" className="mx-2 profile-item">
                <DropdownToggle nav caret id="profileDropDown">
                  <img
                    src={user?.picture}
                    alt="Profile"
                    className="nav-user-profile rounded-circle"
                    width="35"
                  />
                </DropdownToggle>
                <DropdownMenu end className="profile-dropdown-menu">
                  <h6 className="d-inline-block mx-2">{user?.name}</h6>
                  <DropdownItem id="qsLogoutBtn" onClick={logoutWithRedirect}>
                    <FontAwesomeIcon icon="power-off" className="mr-3" />{" "}
                    {t("Navigation-Log out")}
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </Nav>
          </div>
        </Container>
      </Navbar>
    </div>
  );
};

export default NavBar;